
import { useEffect, useState } from "react";
import { useSearchParams, Navigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/contexts/AuthContext";
import { Loader } from "@/components/ui/loader";
import { FcGoogle } from "react-icons/fc";

export default function InvitePage() {
  const [searchParams] = useSearchParams();
  const code = searchParams.get('code');
  const { login, isAuthenticated, isLoading } = useAuth();
  const [isProcessing, setIsProcessing] = useState(false);

  useEffect(() => {
    document.title = "Accept Invitation | Shekel";
  }, []);

  const handleAcceptInvite = async () => {
    if (!code) return;
    
    setIsProcessing(true);
    try {
      await login(code);
    } catch (error) {
      console.error("Error accepting invitation:", error);
    } finally {
      setIsProcessing(false);
    }
  };

  if (!code) {
    return <Navigate to="/login" replace />;
  }

  if (isLoading || isProcessing) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Loader size="lg" />
      </div>
    );
  }

  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-b from-shekel-50 to-white p-4">
      <div className="max-w-md w-full space-y-8 bg-white p-8 rounded-xl shadow-lg">
        <div className="text-center">
          <div className="flex justify-center mb-6">
            <div className="w-20 h-20 bg-shekel-600 rounded-full flex items-center justify-center">
              <span className="text-white text-4xl font-bold">₪</span>
            </div>
          </div>
          <h1 className="text-3xl font-bold text-shekel-800 mb-2">You're Invited!</h1>
          <p className="text-gray-500 mb-8">
            You've been invited to join a family on Shekel. Sign in to get started.
          </p>
          <p className="text-sm text-gray-400 mb-4">
            Invitation Code: <span className="font-mono font-bold">{code}</span>
          </p>
        </div>

        <div className="space-y-4">
          <Button
            onClick={handleAcceptInvite}
            size="lg"
            className="w-full flex items-center justify-center gap-2"
            disabled={isProcessing}
          >
            <FcGoogle className="w-5 h-5" />
            {isProcessing ? "Processing..." : "Accept Invitation with Google"}
          </Button>

          <p className="text-xs text-center text-gray-500 mt-8">
            By continuing, you agree to Shekel's Terms of Service and Privacy Policy.
          </p>
        </div>
      </div>
    </div>
  );
}
